import React from 'react';
import { IC_FILTER_GREEN } from '@common/Assets/images';
import Image from 'next/image';
import DropdownControl from '@common/Component/Forms/Dropdown/Dropdown';
import { useTranslation } from '@common/i18n';


const SearchSortBy = (props) => {
  const t = useTranslation();
  return (
    <div className="dropDownContent">
      {!props.loadingList && props.checkFilterApplied && (
        <>
          <span className="label" >{props.checkFilterApplied ? t('Search.txtSortBy') : null}</span>
          <DropdownControl
            data={{ values: props.sortFilterOptions?.map((item) => item?.displayName) }}
            caption={props.checkFilterApplied ? props.sortBy?.displayName : null}
            handleSelect={props.onSortBy}
          />
        </>
      )}
      <div className="noDesktop showFilter" onClick={() => props.setIsOpen(true)}>
        <Image src={IC_FILTER_GREEN} alt="" layout="fill" />
      </div>
    </div>
  );
};

export default SearchSortBy;
